import { useState } from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';

import { saveMetadataAcademy } from 'store/academy-actions';

import classes from './MetadataModal.module.css';

const MetadataModal = props => {
  const [matricula, setMatricula] = useState(
    props.metadata[0].preloadData
      ? props.metadata[0].preloadData
      : ''
  );
  const [campus, setCampus] = useState(
    props.metadata[1].preloadData
      ? ` ${props.metadata[1].preloadData}`
      : ''
  );
  const [sendData, setSendData] = useState(false);

  const handleChange = () => {
    setMatricula(event.target.value);
  };

  const handleChangeCampus = event => {
    setCampus(event.target.value);
  };

  const saveMetadata = () => {
    setSendData(true);
    const data = [
      {
        tag: `${props.metadata[0].tag}`,
        tagValue:
          props.metadata[0].description === 'Indica tu campus'
            ? campus
            : matricula
      },
      {
        tag: `${props.metadata[1].tag}`,
        tagValue:
          props.metadata[1].description === 'Matrícula del alumno'
            ? matricula
            : campus
      }
    ];
    (async () => {
      const saveData = await saveMetadataAcademy(data);
      if (saveData) {
        props.handleClose();
      }
    })();
  };

  return (
    <Dialog open={props.open}>
      {props.metadata && (
        <>
          <DialogTitle>
            Actualización de información adicional
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Una vez que hayas actualizado tus datos, presiona el
              botón "Guardar Cambios" para acceder normalmente al
              contenido.
            </DialogContentText>
            {props.metadata.map(item =>
              item.options.length >= 2 ? (
                <FormControl fullWidth key={item.name}>
                  <InputLabel id="campusSelect">
                    {item.name}
                  </InputLabel>
                  <Select
                    labelId="campusSelect"
                    value={campus}
                    label={item.name}
                    onChange={handleChangeCampus}
                  >
                    {item.options.map(option => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : (
                <FormControl fullWidth key={item.name}>
                  <TextField
                    label={item.name}
                    value={matricula}
                    onChange={handleChange}
                    margin="normal"
                    variant="outlined"
                    className={classes.inputField}
                  />
                </FormControl>
              )
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={saveMetadata}
              className={classes.saveBtn}
              disabled={!matricula || !campus || sendData}
            >
              Guardar Cambios
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

MetadataModal.propTypes = {
  // eslint-disable-next-line react/require-default-props
  handleClose: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  open: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  metadata: PropTypes.array
};

export default MetadataModal;
